"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PredictionQuestionResolveButton = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const icons_material_1 = require("@mui/icons-material");
const styled_1 = require("@framework/styled");
const PredictionQuestionResolveButton = (props) => {
    const { className, disabled, variant = styled_1.ListActionVariant.iconButton, question } = props;
    const handleClick = () => {
        console.info("CLICK");
    };
    if (!question.startTimestamp || question.endTimestamp) {
        return null;
    }
    return ((0, jsx_runtime_1.jsx)(styled_1.ListAction, { onClick: handleClick, icon: icons_material_1.Done, message: "form.buttons.resolve", className: className, dataTestId: "PredictionQuestionResolveButton", disabled: disabled, variant: variant }));
};
exports.PredictionQuestionResolveButton = PredictionQuestionResolveButton;
//# sourceMappingURL=index.js.map